// @flow

import React from 'react'
import type { Image as ImageType } from 'types/'
import SwiperCore, { Pagination, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import Appear from './Appear'
import Slide from './Slide'

import 'swiper/swiper-bundle.css'

SwiperCore.use([Pagination, Autoplay])

type SlideItem = {
  key: string,
  title: string,
  subtitle: string,
  text: string,
  color: string,
  image: ImageType,
}

type Props = {
  items: Array<SlideItem>
}

const Slider = ({ items }: Props) => {
  const params: any = {
    pagination: {
      clickable: true
    },
    autoplay: {
      delay: 4500,
    },
    spaceBetween: 24
  }

  return (
    <div className="mb-16">
      <Appear>
        <Swiper
          {...params}
          slideclass="swiper-slide"
          slideactiveclass="swiper-slide-active"
          containerclass="swiper-container"
        >
          {items.map(item => (
            <SwiperSlide key={item.key}>
              <Slide {...item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Appear>
    </div>
  )
}

export default Slider
